export default "__VITE_ASSET__Ds2szk8z__"